import { useMemo, memo, useContext } from 'react';
import { AppThemingContext } from '@trinity/chat-components/containers/AppTheming';
import { cx } from '@trinity/chat-components/utils';
import type { FocusableClasses } from './interfaces';
import styles from './style.module.css';

type Props = {
  className?: string;
  classes?: FocusableClasses;
  focused: boolean;
  readOnly?: boolean;
};

export const FocusableAnimation = memo(({ className = '', classes = {}, focused, readOnly }: Props) => {
  const theming = useContext(AppThemingContext);

  const blurClasses = useMemo(() => cx({
    [styles.blurred]: !focused,
    [styles.unblurred]: focused,
  }, cx(className, classes.root, classes.unfocused, classes.invalid)), [
    focused,
    className,
    classes.root,
    classes.unfocused,
    classes.invalid,
  ]);

  const focusClasses = useMemo(() => cx({
    [styles.focused]: focused,
    [styles.unfocused]: !focused,
  }, cx(className, classes.root, classes.focused, classes.invalid)), [
    focused,
    className,
    classes.root,
    classes.focused,
    classes.invalid,
  ]);

  const focusStyle = useMemo(() => {
    return {
      backgroundColor: theming?.enabled ? theming?.palette?.primary?.main : 'var(--pri-02)',
    };
  }, [theming?.palette?.primary?.main, theming?.enabled]);

  if (readOnly) return <div className={styles.readonly} />;

  return (
    <>
      <div className={blurClasses} />
      <div
        className={focusClasses}
        style={focusStyle} />
    </>
  );
});

export default FocusableAnimation;